import create from 'zustand'

const useStore = create((set) => ({
    selectedRewardMapping: null,
    setSelectedRewardMapping: (selectedRewardMapping) => set(() => ({ selectedRewardMapping: selectedRewardMapping })),
}))

export const useGlobalStore = useStore